import { ResponsiveMenuItem } from "@/components/ui/responsive-menu";
import { useCallback } from "react";
import { useTranslation } from "react-i18next";
import { useProjectStoreContext } from "./ProjectStoreContext";
import { useModulePermissions } from "@/modules/account/hooks/useModulePermissions";
import { useCheckIsProjectLocked } from "../hooks/useCheckIsProjectLocked";

const AssignStoresToProjectsMenubarItem = () => {
  const { t } = useTranslation();
  const { setIsAddLimitsDialogOpen } = useProjectStoreContext();
  const { can_update } = useModulePermissions();
  const isProjectLocked = useCheckIsProjectLocked();

  const onAddPeriods = useCallback(() => {
    setIsAddLimitsDialogOpen(true);
  }, [setIsAddLimitsDialogOpen]);

  return (
    <ResponsiveMenuItem
      onClick={onAddPeriods}
      disabled={!can_update || isProjectLocked}
    >
      {t("projects.menubar.store.addLimits")}
    </ResponsiveMenuItem>
  );
};

export default AssignStoresToProjectsMenubarItem;
